import React from 'react';
import { useCms } from '../context/CmsContext';
import BrasilMap from './BrasilMap';

const defaultData = {
  heading: 'Casos de Sucesso',
  subheading: 'Organizações públicas que já transformaram sua gestão com a Nexus.',
  cases: [
    { title: 'Instituto de Terras do Piauí', description: 'Implementação de sistema de gestão de processos para otimizar o atendimento ao cidadão.', color: 'blue', lat: -5.09, lng: -42.81, logo: 'https://s2-g1.glbimg.com/-MR80fiP9iOXkwqoisR9LhaHrVw=/0x0:852x469/984x0/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_59edd422c0c84a879bd37670ae4f538a/internal_photos/bs/2023/Y/j/SPWn0AR4qG91WIj3Bp6g/marca-pi.jpg' },
    { title: 'Porto Digital — Recife', description: 'Gestão integrada de projetos e monitoramento de indicadores para inovação urbana.', color: 'orange', lat: -8.05, lng: -34.88, logo: 'https://upload.wikimedia.org/wikipedia/commons/b/bc/Marca_Porto_Digital_2019_completa.png' },
    { title: 'Governo de Roraima', description: 'Gestão de processos e monitoramento de desempenho.', color: 'blue', lat: 2.82, lng: -60.67, logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ed/Bras%C3%A3o_de_Roraima.svg/1920px-Bras%C3%A3o_de_Roraima.svg.png' },
    { title: 'Câmara Municipal de Palmas', description: 'Sistema de votação eletrônica e gestão de projetos legislativos.', color: 'orange', lat: -10.18, lng: -48.33, logo: 'https://upload.wikimedia.org/wikipedia/commons/d/d1/Bras%C3%A3o_de_Palmas_%28TO%29.png' },
  ],
};

const colorMap = {
  blue:   { bg: 'bg-white', badge: 'bg-blue-50 text-blue-900', dot: 'bg-blue-900' },
  orange: { bg: 'bg-white', badge: 'bg-orange-50 text-orange-700', dot: 'bg-orange-500' },
};

const CasosSucessoSection = () => {
  const cms = useCms('casos_sucesso', defaultData);
  const cases = cms.cases || defaultData.cases;

  return (
    <section id="casos" className="py-24 bg-white">
      <div className="container mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {cms.heading || defaultData.heading}
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            {cms.subheading || defaultData.subheading}
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-12">
          <div className="w-full lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {cases.map((item, index) => {
              const colors = colorMap[item.color] || colorMap.blue;
              return (
                <div
                  key={index}
                  className={`${colors.bg} border border-gray-200 rounded-xl p-6 hover:shadow-md transition-all duration-200`}
                >
                  <div className="flex items-center justify-between mb-4">
                    <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold ${colors.badge}`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${colors.dot}`} />
                      Caso de Sucesso
                    </div>
                    {item.logo && (
                      <img src={item.logo} alt={item.title} className="h-9 w-auto max-w-[72px] object-contain" />
                    )}
                  </div>
                  <h3 className="text-base font-bold text-gray-800 mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.description}</p>
                </div>
              );
            })}
          </div>

          <div className="w-full lg:w-1/2 flex justify-center items-start">
            <BrasilMap pins={cases.filter(c => c.lat && c.lng)} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CasosSucessoSection;
